import PropTypes from 'prop-types';
import React from 'react';

import { withModal, YoutubePlayer } from '@sm360/widget-commons-general';

import 'build-and-quote/components/Summary/components/VehicleVideo/VehicleVideoModal.scss';

const MODAL = 'BuildAndQuote/VehicleVideo';

class VehicleVideoModal extends React.PureComponent {
    render() {
        const { videoURL, modal } = this.props;

        return (
            <div className="VehicleVideoModal">
                <button onClick={modal.close}>
                    <icon className="icon-X-rouge" />
                </button>
                <YoutubePlayer videoURL={videoURL} />
            </div>
        );
    }
}

VehicleVideoModal.propTypes = {
    videoURL: PropTypes.string.isRequired,
    modal: PropTypes.shape.isRequired,
};

VehicleVideoModal.displayName = 'VehicleVideoModal';

export { VehicleVideoModal };
export default withModal(MODAL)(VehicleVideoModal);
